var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaEnkeltHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.75,
    viewBox: "0 0 20 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M3.712,1.438A1.25,1.25,0,0,1,4.662,1H15.338a1.25,1.25,0,0,1,.95.438l3.261,3.8A1.875,1.875,0,0,1,20,6.463v.319A2.969,2.969,0,0,1,14.688,8.6,2.969,2.969,0,0,1,10,8.6a2.969,2.969,0,0,1-4.687,0A2.969,2.969,0,0,1,0,6.781V6.463a1.875,1.875,0,0,1,.451-1.22L3.714,1.436ZM5.937,6.781a1.719,1.719,0,1,0,3.438,0,.625.625,0,1,1,1.25,0,1.719,1.719,0,1,0,3.438,0,.625.625,0,0,1,1.25,0,1.719,1.719,0,1,0,3.438,0V6.463a.625.625,0,0,0-.15-.406L15.338,2.25H4.662L1.4,6.056a.625.625,0,0,0-.15.406v.319a1.719,1.719,0,1,0,3.438,0,.625.625,0,0,1,1.25,0ZM1.875,10.375A.625.625,0,0,1,2.5,11v7.5H3.75V12.25A1.25,1.25,0,0,1,5,11H8.75A1.25,1.25,0,0,1,10,12.25V18.5h7.5V11a.625.625,0,1,1,1.25,0v7.5h.625a.625.625,0,1,1,0,1.25H.625a.625.625,0,1,1,0-1.25H1.25V11A.625.625,0,0,1,1.875,10.375ZM5,18.5H8.75V12.25H5Zm6.25-6.25A1.25,1.25,0,0,1,12.5,11H15a1.25,1.25,0,0,1,1.25,1.25V16A1.25,1.25,0,0,1,15,17.25H12.5A1.25,1.25,0,0,1,11.25,16Zm3.75,0H12.5V16H15Z",
    transform: "translate(0 -1)",
    fill: "#222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltHome);
export default __webpack_public_path__ + "static/media/sa-enkelt-home.5e9bd7a9660f2698b310ed44f1607d87.svg";
export { ForwardRef as ReactComponent };